import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {DateRangePicker} from '../common/SelectDateRange';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';

export default function BranchActivitiesAdmin() {
	const {dataSource, setDataSource, setCurrentItem, copyDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/home/api!organizationBranchActivity.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const detailClick = (item) => {
		setCurrentItem(item);
		window.open(Arguments.reactUrl + '/activity/branch-activities-admin/detail', '_self');
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 90,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
			width: 200,
		},
		{
			title: '活动主题',
			dataIndex: 'activity_name',
			width: 200,
		},
		{
			title: '主持人',
			dataIndex: 'activity_compere',
			width: 120,
		},
		{
			title: '活动时间',
			dataIndex: 'activity_date',
			width: 120,
			sorter: (a, b) => new Date(a.activity_date) - new Date(b.activity_date),
			sortDirections: ['ascend', 'descend', 'ascend'],
		},
		{
			title: '活动地点',
			dataIndex: 'activity_address',
			width: 200,
		},
		{
			title: '活动类别',
			responsive: ['lg'],
			dataIndex: 'activity_form',
			width: 120,
		},
		{
			title: '参加人数',
			dataIndex: 'activity_scope',
			width: 100,
		},
		{
			title: '操作',
			width: 120,
			render: (item) => (
				<Button type="link" onClick={() => detailClick(item)}>查看详情</Button>
			),
		},
	];

	const indexDataSource = dataSource.map(
		(data, index) => ({showIndex: index + 1, ...data, activity_memo: data.activity_memo.substring(0, 32000)}));

	const newData = indexDataSource.map(
		(
			{
				organization_name,
				activity_name,
				activity_compere,
				activity_date,
				activity_address,
				activity_form,
				activity_scope,
				activity_memo,
			},
		) => (
			{
				'社会组织': organization_name,
				'活动主题': activity_name,
				'主持人': activity_compere,
				'活动时间': activity_date,
				'活动地点': activity_address,
				'活动类别': activity_form,
				'参加人数': activity_scope,
				'活动备注': activity_memo,
			}
		),
	);

	return (
		<>
			<ExportToExcel tableData={newData}/>
			<DateRangePicker dataSource={dataSource} setDataSource={setDataSource} copyDataSource={copyDataSource}/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}


